import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useBackButtonToPrevRoute } from '@/hooks/useBackButtonToPrevRoute.tsx';
import { routes } from '@/navigation/routes.tsx';
import { InputContent } from '@/components/common/InputContent/InputContent.tsx';
import { MenuItem } from '@/components/Profile/MenuItem/MenuItem.tsx';
import { helpers } from '@/helpers.ts';
import usePolicy from '@/hooks/usePolicy.ts';
import { blockContainer } from '@/pages/Profile/Settings/styles.ts';

const ProfileSettings: FC = () => {
  useBackButtonToPrevRoute(routes.profile);
  const { t } = useTranslation();
  const { isBeingVerified } = usePolicy();
  const navigate = useNavigate();

  const settingsItems = [
    {
      onClick: () => navigate(routes.profileNotifications),
      labelKey: 'notifications_menu_item'
    },
    {
      onClick: () => navigate(routes.profilePrivacy),
      labelKey: 'privacy_menu_item'
    },
    ...(isBeingVerified
      ? []
      : [
          {
            onClick: () => navigate(routes.profileAccount),
            labelKey: 'account_menu_item'
          }
        ]),
    {
      onClick: () => navigate(routes.selectLocale),
      labelKey: 'language_menu_item'
    }
  ];

  return (
    <div
      style={{
        height: 'calc(100vh - 100px)',
        paddingTop: '100px',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <InputContent title={t('profile_settings')}>
        <div style={blockContainer}>
          {settingsItems.map(({ onClick, labelKey }) => (
            <MenuItem key={labelKey} labelKey={labelKey} onClick={onClick} />
          ))}
        </div>
        <div style={{ ...blockContainer, marginTop: 10 }}>
          <MenuItem
            labelKey="news_channel_menu_item"
            onClick={() =>
              window.open(
                helpers.getEnvVar(
                  'VITE_NEWS_CHANNEL_DEEPLINK',
                  'https://t.me/KyivDateNews'
                ),
                '_blank'
              )
            }
          />
          <MenuItem
            labelKey="support_menu_item"
            onClick={() => navigate(routes.support)}
          />
        </div>
      </InputContent>
    </div>
  );
};

export default ProfileSettings;